/**
 * 组件使用场景：查看银行卡号
 * */
import React, { Component } from 'react';
import { Modal } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({
    buyer: rootState.buyer,
});
class BankCode extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.cancel = this.cancel.bind(this);
    }
    cancel() {
        dispatch.buyer.SET_STATE({
            showBank: false,
        });
    }
    render() {
        const { showBank, bankMsg } = this.props.buyer;
        return (<Modal title={'银行卡账号查看'} visible={showBank} onCancel={this.cancel} footer={null} centered={true}>
        <div>{bankMsg.bankName}</div>
        <div>{bankMsg.bankCode}</div>
      </Modal>);
    }
}
export default connect(mapStateToProps)(BankCode);
